import React from "react";

const CustomTextAreaUncontrolled = React.memo(
  ({
    label,
    placeholder,
    required,
    noMarginBottom,
    defaultValue,

    onValueCommit, // 🔑 called onBlur
    error, // 🔑 validation message
    ...props
  }) => {
    return (
      <div className={`${noMarginBottom == true ? "" : "mb-2"}`}>
        {label && (
          <label className="mb-1">
            {label} {required && <span className="text-danger">*</span>}
          </label>
        )}

        <textarea
          {...props}
          defaultValue={defaultValue}
          placeholder={placeholder}
          autoComplete={"off"}
          className="form-control form-control-sm"
          onBlur={(e) => {
            onValueCommit?.(e.target.value);
          }}
        />

        {/* 🔴 VALIDATION MESSAGE */}
        {error && (
          <div className="invalid-feedback animated fadeInUp d-block">
            {error}
          </div>
        )}
      </div>
    );
  },
);

export default CustomTextAreaUncontrolled;
